import appStoreBadge from '@assets/app-store-badge.svg';
import googlePlayBadge from '@assets/google-play-badge.svg';
import { ModalBox, useModalContext } from '@fourthwall/components';
import { MOBILE_APP_ANDROID_LINK, MOBILE_APP_IOS_LINK } from '@fourthwall/utils/dist/links';
import React from 'react';
import * as S from './ThankYousNotSupported.styled';
export const ThankYousNotSupported = () => {
    const { close } = useModalContext();
    return (React.createElement(ModalBox, { onClose: close, size: "small", title: "Browser not supported" },
        React.createElement(React.Fragment, null,
            "Your current operating system and browser combination doesn\u2019t support recording thank yous at the moment. While our team is working on a fix, you can try to use other browsers or our mobile app to record thank yous.",
            React.createElement(S.MobileAppContainer, null,
                React.createElement("div", null,
                    React.createElement(S.MobileAppLink, { href: MOBILE_APP_IOS_LINK, target: "_blank", rel: "noreferrer" },
                        React.createElement(S.MobileAppImage, { src: appStoreBadge, alt: "App Store Badge" }))),
                React.createElement("div", null,
                    React.createElement(S.MobileAppLink, { href: MOBILE_APP_ANDROID_LINK, target: "_blank", rel: "noreferrer" },
                        React.createElement(S.MobileAppImage, { src: googlePlayBadge, alt: "Google Play Badge" })))))));
};
